export default __webpack_public_path__ + "static/media/pwaIosSafariImage.fcba82cb.png";